
// custom components
import AccountAvatar from '../accountDetail/AccountAvatar'
import { Text } from '../../../1elements'
import DataAdmin from './DataAdmin'
import SetToDefaultButton from '../../../1elements/Buttons/IconButtons/SetToDefaultButton'

// mui
import { makeStyles } from '@material-ui/core/styles'

// third party libraries
import { Reorder } from 'framer-motion'
import { useParams } from 'react-router-dom'

const ServiceDetailAdmin = ({ data, reorderFields, index, updateFieldLabel, isCardDirty, resetToDefault, toggleIsHidden, updateDataType }) => {
  const { tabName } = useParams()
  const { cardMetadataId } = data
  const serviceTab = tabName === 'tab2'
  const classes = useStyles({ serviceTab })

  return (
    <div className={classes.root} key={index}>
      {
                isCardDirty && (
                  <SetToDefaultButton
                    onClick={() => resetToDefault(index, cardMetadataId)}
                    className={classes.resetToDefaultButton}
                  />
                )
            }

      <AccountAvatar accountName='' />
      <div className={classes.textDiv}>
        <Text type='h10' className={classes.serviceName}>{serviceTab ? 'Service Name' : 'FULL NAME'}</Text>
        <Reorder.Group
          values={data} onReorder={(newValue) => reorderFields(newValue, index)}
          className={classes.dataGrid}
        >
          {
                        data && data.map((field, fieldIndex) => {
                          const { isArchived, label, fieldId } = field
                          if (label !== 'Service Name' && label !== 'Contact Name' && !isArchived) {
                            return (
                              <DataAdmin
                                key={fieldId} data={field} index={index} fieldIndex={fieldIndex}
                                updateFieldLabel={updateFieldLabel} toggleIsHidden={toggleIsHidden} updateDataType={updateDataType}
                              />
                            )
                          }
                          return null
                        })
            }
        </Reorder.Group>
      </div>
    </div>
  )
}

export default ServiceDetailAdmin

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%'
  },
  serviceName: {
    marginLeft: 25
  },
  textDiv: {
    marginLeft: 20,
    flexGrow: 2
  },
  dataGrid: {
    padding: 0,
    display: 'grid',
    gridTemplateRows: props => props.serviceTab ? 'repeat(5, 1fr)' : 'repeat(3, 1fr)',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '3px 20px',
    width: '100%',
    height: '90%'
  },
  resetToDefaultButton: {
    position: 'absolute',
    right: 35,
    top: 20,
    zIndex: 1,
    '& .MuiButtonBase-root': {
      padding: 0
    }
  }
}))
